import { Injectable , Injector  } from '@angular/core';
import {  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import {  switchMap } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login.service';

@Injectable()
export class HttpIntercepter implements HttpInterceptor {
  constructor( private authService :LoginService) {}



  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  return from(this.authService.getToken())
  .pipe(
    switchMap(token => {
       const headers = request.headers
                .set('Authorization', 'Bearer ' + token)
                .append('Content-Type', 'application/json');
       const requestClone = request.clone({
         headers 
        });
      return next.handle(requestClone);
    })
   );
}
   
}
  
  
  